module.exports = __webpack_public_path__ + "img/voszport-logo.e5a20406.png";